/*
  SZW 10/11: two-step Size picker (Roll | Sample, then Roll size: 2 yd | 3.3 yd) - see snippets/szw-roll-size.liquid.
  Row 2 radios are not option inputs: picking one copies its value + option value id onto the row 1 "Roll" radio,
  checks it and fires its change event, so variant-selects / product-info select the matching Shopify variant
  exactly as a normal option click would (price, quantity rules, cart line, ?variant=).
*/
(function () {
  if (window.szwRollSize) return;

  function picker(el) { return el && el.closest('variant-selects'); }
  function sizeRow(vs) { return vs && vs.querySelector('[data-szw-roll-size]'); }
  function rollInput(vs) { return vs && vs.querySelector('[data-szw-roll-main]'); }
  function shown(el) {
    var lab = el && el.id && document.querySelector('label[for="' + el.id + '"]');
    return !!(lab && lab.offsetParent !== null);
  }

  // Row 1 reads "Size: Roll" (the stock handler writes the full value, "Roll 3.3 yd"); row 2 shows only with Roll.
  function sync(vs) {
    var roll = rollInput(vs), row = sizeRow(vs);
    if (!roll || !row) return;
    var label = roll.closest('.product-form__input');
    label = label && label.querySelector('[data-selected-swatch-value]');
    if (roll.checked && label) label.textContent = 'Roll';
    row.hidden = !roll.checked;
    var cur = row.querySelector('input:checked'), out = row.querySelector('[data-szw-roll-size-value]');
    if (cur && out) out.textContent = cur.getAttribute('data-szw-label');
  }

  function choose(vs, size) {
    var roll = rollInput(vs);
    if (!roll || !size) return false;
    size.checked = true;
    roll.value = size.value;
    roll.setAttribute('data-option-value-id', size.getAttribute('data-szw-option-value-id'));
    roll.classList.toggle('disabled', size.classList.contains('disabled'));
    roll.checked = true;
    roll.dispatchEvent(new Event('change', { bubbles: true }));
    sync(vs);
    return true;
  }

  // Capture phase on document runs before variant-selects' own (capture) listener, so a row 2 change never
  // reaches it as an option change of its own.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-szw-roll-size]')) {
      event.stopPropagation();
      choose(picker(target), target);
      return;
    }
    var vs = picker(target);
    if (vs && sizeRow(vs)) setTimeout(function () { sync(vs); }, 0);
  }, true);

  window.szwRollSize = {
    // the estimator's "Use 3.3 yd rolls": a visible two-step picker offering that value
    find: function (value) {
      var rows = document.querySelectorAll('[data-szw-roll-size]');
      for (var i = 0; i < rows.length; i++) {
        var vs = picker(rows[i]);
        if (!shown(rollInput(vs))) continue;
        var inputs = rows[i].querySelectorAll('input[type="radio"]');
        for (var j = 0; j < inputs.length; j++) if (inputs[j].value === value) return { vs: vs, input: inputs[j] };
      }
      return null;
    },
    has: function (value) { return !!this.find(value); },
    pick: function (value) {
      var hit = this.find(value);
      return hit ? choose(hit.vs, hit.input) : false;
    }
  };
})();
